import { TIME_OF_LONG_REQUEST } from '../../../config';

export default {
   name: 'Spinner',
   props: {
      loading: {
         type: Boolean
      }
   },
   data() {
      return {
         _loadingTimerId: 0,
         showLoading: false
      };
   },
   methods: {
      _refresh() {
         if (this.loading) {
            this._startLoading();
         } else {
            this._loaded();
         }
      },

      _startLoading() {
         this._loadingTimerId = setTimeout(() => this.showLoading = true, TIME_OF_LONG_REQUEST);
      },
      _loaded() {
         clearTimeout(this._loadingTimerId);
         this.loading = false;
         this.showLoading = false;
      }
   },
   watch: {
      loading() {
         this._refresh();
      }
   },
   created() {
      this._refresh();
   }
};
